import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { collection, doc, getDocs, query, where, orderBy } from "firebase/firestore";
import { db } from "../../firebase";
import styles from "./Dashboard.module.css";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../../contexts/userContext";
import { Button, Heading, Modal, Navbar, Popup, DocMenu } from "../../components";
import { ResumeContext } from "../../contexts/resumeContext";
import { templates } from "../../utils/constants";
import {
  CloudDownloadAnimated,
  Loader,
  Plus,
  Edit,
  Delete
} from "../../components/Icons/Icons";
import { sleep } from "../../utils/functions";

function Dashboard() {
  const navigate = useNavigate();
  const { user, userLoading } = useContext(UserContext);
  const { setResumeInfo } = useContext(ResumeContext);
  const [docs, setDocs] = useState([]);
  const [showModal, toggleModal] = useState(false);
  const [showDocMenu, toggleDocMenu] = useState(false)

  useEffect(() => {
    if (user) getResumes();
    // const docs = [];
  }, [user]);

  const getResumes = async () => {
    let resumes = [];
    toggleModal(true);
    const q = query(
      collection(db, "documents"),
      where("user", "==", user?.uid),
      orderBy('createdAt', 'desc')
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      resumes = [...resumes, { ...doc.data(), id: doc.id }];
    });

    setDocs(resumes);
    await sleep(1000);
    toggleModal(false);
  };

  const getTemplateImage = (design) => {
    let template = templates.filter((item) => item.name == design);
    if (template?.[0]) {
      return template[0].img;
    }
    return "";
  };

  const handleResumeClick = (id) => {
    setResumeInfo({});
    navigate(`resume/${id}/edit/?section=personal`);
  };

  if (userLoading) {
    return (
      <>
        <Navbar />
        <Modal active>
          <div className={styles.modal}>
            <div className={styles.svg}>
              <CloudDownloadAnimated />
            </div>
            <p className={styles.modalText}>
              Just a moment <br />
              Fetching your resumes...
            </p>
          </div>
        </Modal>
      </>
    );
  }

  if (!user) {
    return (
      <>
        <Navbar />
        <div className={styles.emptyDashboard}>
          <Heading
            content="You're not logged in right now"
            style={{ flex: 1, textAlign: "center", marginBottom: "1em" }}
          />
          <div>
            <Link to="/designs">
              <Button content="Create New Resume" />
            </Link>{" "}
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Link to="/login">
              <Button outlined content="Log in" />
            </Link>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className={styles.dashboard}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h1>My Resumes</h1>

          <Link to="designs" className={styles.button}>
            <Plus />
            &nbsp; Create new resume
          </Link>
        </div>
        <div className={styles.row}>
          {docs?.map((doc) => {
            const templateImg = getTemplateImage(doc.design);
            return (
              <div
                key={doc.id}
                className={styles.card}
                onClick={() => handleResumeClick(doc.id)}
              >
                {doc.design && <div className={styles.imgWrapper}><img src={templateImg} className="image" /></div>}
                <div className={styles.docInfo}>
                  <div>
                    <p className={styles.docName}>{doc.name}</p>
                    <p className={styles.docDate}>
                      Created: {doc?.createdAt?.toDate()?.toLocaleString()}
                    </p>
                  </div>
                  <div className={styles.docActions}>
                    <button className={styles.docMenu} onClick={(e) => {e.preventDefault(); e.stopPropagation(); toggleDocMenu(doc.id)}}>
                      <span></span>
                      <span></span>
                      <span></span>
                    </button>
                        {(showDocMenu === doc.id) &&(
                          <DocMenu getResumes={getResumes} docs={docs} setDocs={setDocs} currentDoc={doc} docId={doc.id} onClose={() => toggleDocMenu(false)}/>
                      )}

                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <Modal active={showModal}>
          <div className={styles.modal}>
            <div className={styles.svg}>
              <CloudDownloadAnimated />
            </div>
            <p className={styles.modalText}>
              Just a moment <br />
              Fetching your resumes...
            </p>
          </div>
        </Modal>
      </div>
    </>
  );
}

export default Dashboard;
